/**
 * Licence status labels and badge styles for BOP (admin) app.
 */

const STATUS_STYLES = {
  Pending: { bg: 'bg-yellow-100', text: 'text-yellow-800', label: 'Awaiting Review' },
  'Awaiting Review': { bg: 'bg-yellow-100', text: 'text-yellow-800', label: 'Awaiting Review' },
  'Under Review': { bg: 'bg-blue-100', text: 'text-blue-800', label: 'Under Review' },
  'Re-review': { bg: 'bg-blue-100', text: 'text-blue-800', label: 'Re-review' },
  'Under Review – Additional Info Required': { bg: 'bg-blue-100', text: 'text-blue-800', label: 'Under Review – Additional Info Required' },
  'Under Review - Additional Info Required': { bg: 'bg-blue-100', text: 'text-blue-800', label: 'Under Review – Additional Info Required' },
  Reviewed: { bg: 'bg-green-100', text: 'text-green-800', label: 'Reviewed' },
  'Ready for Signature': { bg: 'bg-green-100', text: 'text-green-800', label: 'Ready for Signature' },
  'Terms & Conditions Signed': { bg: 'bg-teal-100', text: 'text-teal-800', label: 'Terms & Conditions Signed' },
  Approved: { bg: 'bg-emerald-100', text: 'text-emerald-800', label: 'Approved' },
  Granted: { bg: 'bg-emerald-100', text: 'text-emerald-800', label: 'Approved' },
  Rejected: { bg: 'bg-red-100', text: 'text-red-800', label: 'Rejected' },
  Archived: { bg: 'bg-gray-100', text: 'text-gray-800', label: 'Archived' },
  Expired: { bg: 'bg-gray-100', text: 'text-gray-800', label: 'Expired' }
};

const DEFAULT_STYLE = { bg: 'bg-gray-100', text: 'text-gray-800', label: 'Awaiting Review' };

/**
 * @param {string} status - Raw status from API
 * @returns {{ bg: string, text: string, label: string }}
 */
export function getStatusStyle(status) {
  const raw = status && typeof status === 'string' ? status.trim() : '';
  if (!raw) {
    return DEFAULT_STYLE;
  }
  const config = STATUS_STYLES[raw];
  if (config) {
    return { ...config, label: config.label || raw };
  }
  return { ...DEFAULT_STYLE, label: raw };
}
